import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import InlineButton from 'components/InlineButton';
import ModalDialog from 'components/ModalDialog';
import { addDataLayer } from 'lib/GoogleTagManager';

const Wrapper = styled.button`
  background-color: transparent;
  border: none;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 3rem;
  min-width: 3rem;
`;

const OptionsWrapper = styled.div`
  display: flex;
  flex-direction: column;

  >.InlineButton{
    padding: ${({ theme }) => theme.spacing * 3}px ${({ theme }) => theme.spacing * 2}px;
    border-bottom: 1px solid ${({ theme }) => theme.palette.colors.grey45};
    font-size: 1.4rem;
    font-weight: 400;

    &:last-child {
      border-bottom: none;
    }
  }
`;

const Dropdown = ({
  className, labelComponent, options, dataLayer,
}) => {
  const classes = ['Dropdown'];
  const [showModal, setShowModal] = React.useState(false);
  const buttonRef = React.useRef();

  function toggleModal() {
    if (dataLayer) {
      addDataLayer(dataLayer);
    }
    setShowModal(!showModal);
  }

  function handleClick(cb) {
    return (data) => {
      setShowModal(false);
      cb(data);
    };
  }

  if (className) classes.push(className);

  return (
    <Wrapper
      className={classes.join(' ')}
      onClick={toggleModal}
      dataLayer={dataLayer}
      ref={buttonRef}
    >
      {labelComponent}
      {showModal && (
        <ModalDialog
          anchorTo={buttonRef.current}
          onClose={() => setShowModal(false)}
          align="bottom"
        >
          <OptionsWrapper>
            {options.map((o) => (
              <InlineButton
                key={o.key}
                dataLayer={o.dataLayer}
                onClick={handleClick(o.onClick)}
              >
                {o.label}
              </InlineButton>
            ))}
          </OptionsWrapper>
        </ModalDialog>
      )}
    </Wrapper>
  );
};

Dropdown.displayName = 'Dropdown';

Dropdown.propTypes = {
  className: PropTypes.string,
  labelComponent: PropTypes.node.isRequired,
  dataLayer: PropTypes.shape({
    action: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  }),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      dataLayer: PropTypes.shape({
        action: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
      }),
      onClick: PropTypes.func.isRequired,
      label: PropTypes.node.isRequired,
    }),
  ).isRequired,
};

Dropdown.defaultProps = {
  className: null,
  dataLayer: null,
};

export default Dropdown;
